import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FeatherModule } from 'angular-feather';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { LayoutModule } from '@angular/cdk/layout';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

/**Components**/
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { CustomizerService } from './services/customizer.service';
import { VerticalHeaderComponent } from './layouts/full/header/vertical-header/vertical-header.component';
import { HorizontalHeaderComponent } from './layouts/full/header/horizontal-header/horizontal-header.component';
import { VerticalSidebarComponent } from './layouts/full/sidebar/vertical-sidebar/vertical-sidebar.component';
import { Hnavbar } from './layouts/full/sidebar/horizontal-sidebar/navbar/hnavbar.component';
import { MenuListItemComponent } from './layouts/full/sidebar/vertical-sidebar/menu-list-item/menu-list-item.component';
import { HorizontalSidebarComponent } from './layouts/full/sidebar/horizontal-sidebar/horizontal-sidebar.component';
import { CustomizerComponent } from './layouts/full/customizer/customizer.component';
import { allIcons } from 'angular-feather/icons';
import { LogoComponent } from './layouts/full/logo/logo.component';
import { CarouselModule } from './components/carousel/carousel.module';
import { environment } from 'src/environments/environment';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { FilesizePipe } from './pipes/filesize.pipe';
// import { AppInputComponent } from './components/app-input/app-input.component';
import { AddUserComponent } from './components/snackbars/add-user/add-user.component';
import { AddCurrencyComponent } from './components/snackbars/add-currency/add-currency.component';
import { SendInviteComponent } from './components/snackbars/send-invite/send-invite.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderModule } from './components';

import { SurveyPendingFormComponent } from './components/master-data/survey-pending-form/survey-pending-form.component';
import { ControlsModule } from "./components/controls/controls.module";
import { DamagedContainerComponent } from './components/master-data/damaged-container/damaged-container.component';
import { FormFieldsModule } from "./components/form-fields/form-fields.module";
import { NgChartsModule } from 'ng2-charts';
import { RetryInterceptor } from './interceptor/retry.interceptor';
import { PipesModule } from './pipes/pipes.module';
import { ToastrModule } from 'ngx-toastr';
// import { OpsDateChangeViewComponent } from './pages/ops-data-change/ops-date-change-view/ops-date-change-view.component';
// import { MyApprovalsHomeComponent } from './pages/dashboards/my-approvals-home/my-approvals-home.component';
// import { CancelDialogBoxComponent } from './components/dialog-box/cancel-dialog-box/cancel-dialog-box.component';
// import { ContainerlistforpickupComponent } from './components/external-dashboards/containerlistforpickup/containerlistforpickup.component';
// import { ContainerOffHireComponent } from './container-off-hire/container-off-hire.component';
// import { ValidateOffHireContainerComponent } from './validate-off-hire-container/validate-off-hire-container.component';
// import { ContainerListComponent } from './components/external-dashboards/container-list/container-list.component';
// import { ValidateContainersComponent } from './components/external-dashboards/validate-containers/validate-containers.component';

// import { RepaiEstimateRepairedComponent } from './components/master-data/repai-estimate-repaired/repai-estimate-repaired.component';

// import { RepairEstimateLineItemComponent } from './components/master-data/repair-estimate-line-item/repair-estimate-line-item.component';
// import { ContactTableComponent } from './components/master-data/contact-table/contact-table.component';

// import { Ng2SearchPipeModule } from 'ng2-search-filter';

// import { ContainerNumberComponent } from './components/master-data/container-number/container-number.component';
// import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
// import { MasterSearchComponent } from './components/master-search/master-search/master-search.component';
// import { FileDragNDropDirective } from './components/master-data/custom-stepper/file-drag-n-drop.directive';
//import { NavService } from './services/nav.service';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    wheelSpeed: 2,
    wheelPropagation: true,
};
@NgModule({
    declarations: [
        AppComponent,
        FullComponent,
        BlankComponent,
        VerticalHeaderComponent,
        HorizontalHeaderComponent,
        VerticalSidebarComponent,
        Hnavbar,
        MenuListItemComponent,
        HorizontalSidebarComponent,
        CustomizerComponent,
        LogoComponent,
        AddUserComponent,
        AddCurrencyComponent,
        SendInviteComponent,
        SurveyPendingFormComponent,
        DamagedContainerComponent,
        // OpsDateChangeViewComponent,
        // MyApprovalsHomeComponent,
        // CancelDialogBoxComponent,
        // ContainerlistforpickupComponent,
        // ContainerOffHireComponent,
        // ValidateOffHireContainerComponent,
        // ContainerListComponent,
        // ValidateContainersComponent,
        // RepaiEstimateRepairedComponent,
        // RepairEstimateLineItemComponent,
        // UserDeptAccessTableComponent,
        // MasterSearchComponent,
        // FileDragNDropDirective,
        // SelectFieldComponent, AutoSearchComponent, NumberFieldComponent, TextFieldComponent,
    ],
    providers: [
        ...environment.providers,
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RetryInterceptor,
            multi: true
        },
        CustomizerService,
        DatePipe,
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        MaterialModule,
        FormsModule,
        FeatherModule.pick(allIcons),
        FlexLayoutModule,
        BrowserAnimationsModule,
        HttpClientModule,
        PerfectScrollbarModule,
        LayoutModule,
        CarouselModule,
        DragDropModule,
        NgxDropzoneModule,
        NgxMaterialTimepickerModule,
        ReactiveFormsModule,
        NgSelectModule,
        LoaderModule,
        // Ng2SearchPipeModule
        ControlsModule,
        FormFieldsModule,
        NgChartsModule,
        PipesModule,
        ToastrModule.forRoot()
    ]
})
export class AppModule { }
